import React, {Component} from "react";
import PropTypes from "prop-types";
import DatePicker from "material-ui/DatePicker";
import {FieldTitle} from "admin-on-rest";
import calendarIcon from "../images/calendar.svg";
import BackspaceIcon from "material-ui/svg-icons/content/backspace";
import IconButton from "material-ui/IconButton";
import {BMTheme} from "../BMTheme";

let DateTimeFormat;
DateTimeFormat = global.Intl.DateTimeFormat;

export const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }

  return date;
};

class DateInput extends Component {
  onChange = (_, date) => {
    this.props.input.onChange(date.toISOString());
    this.props.input.onBlur();
  };

  clearDate = () => {
    this.props.input.onChange(null);
    this.props.input.onBlur();
  };

  onBlur = () => {};

  onDismiss = () => this.props.input.onBlur();

  render() {
    const {
      input,
      isRequired,
      label,
      meta,
      options,
      source,
      elStyle,
      resource,
      locale,
      customLabelStyle,
      leftLabel,
      afterLabelText,
      wrapperStyle,
      underlineShow,
      hideCalendarDate,
      textFieldStyle,
      afterInputTextStyle,
      customInputStyle,
      showIcon,
      isDesktop,
      removeDate
    } = this.props;
    if (typeof meta === "undefined") {
      throw new Error(
        "The DateInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    return (
      <div style={wrapperStyle}>
        {showIcon ? (
          <div style={{paddingTop: "1.5%", marginRight: "3%"}}>
            <img src={calendarIcon} alt="calendarIcon" />
          </div>
        ) : null}

        <div style={customLabelStyle}>
          {leftLabel ? (
            <FieldTitle
              label={leftLabel}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          ) : null}

          {afterLabelText ? (
            <span style={afterInputTextStyle}>{afterLabelText}</span>
          ) : null}
        </div>

        {isDesktop === true ? (
          <div>
            <DatePicker
              {...input}
              inputStyle={customInputStyle}
              errorText={touched && error}
              floatingLabelText={
                <FieldTitle
                  label={label}
                  source={source}
                  resource={resource}
                  isRequired={isRequired}
                />
              }
              underlineShow={underlineShow}
              DateTimeFormat={Intl.DateTimeFormat}
              hideCalendarDate={hideCalendarDate}
              locale={locale}
              formatDate={
                new DateTimeFormat("sv", {
                  day: "numeric",
                  month: "long",
                  year: "numeric"
                }).format
              }
              container="dialog"
              autoOk
              textFieldStyle={textFieldStyle}
              value={datify(input.value)}
              onChange={this.onChange}
              onBlur={this.onBlur}
              onDismiss={this.onDismiss}
              style={{float: "left"}}
              {...options}
            />
            {removeDate === true && (
              <div
                style={{
                  paddingTop: 20,
                  float: "left"
                }}
              >
                <IconButton onClick={this.clearDate}>
                  <BackspaceIcon color={BMTheme.palette.primary1Color} hoverColor={BMTheme.palette.iconHoverColor} />
                </IconButton>
              </div>
            )}
          </div>
        ) : (
          <DatePicker
            {...input}
            inputStyle={customInputStyle}
            errorText={touched && error}
            hintText={
              <FieldTitle
                label={label}
                source={source}
                resource={resource}
                isRequired={isRequired}
              />
            }
            underlineShow={underlineShow}
            DateTimeFormat={Intl.DateTimeFormat}
            hideCalendarDate={hideCalendarDate}
            locale={locale}
            formatDate={
              new DateTimeFormat("sv", {
                day: "numeric",
                month: "long",
                year: "numeric"
              }).format
            }
            container="dialog"
            autoOk
            textFieldStyle={textFieldStyle}
            value={datify(input.value)}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onDismiss={this.onDismiss}
            style={elStyle}
            {...options}
          />
        )}
      </div>
    );
  }
}

DateInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string
};

DateInput.defaultProps = {
  addField: true,
  options: {}
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/DateInput.js